import { css } from "@emotion/react"

import COLOR_CODE from "../../constant/color"

type Props = { children: string; className?: string }

const OneClickErrorText = ({ children, className }: Props) => {
  return (
    <p css={style} className={className}>
      {children}
    </p>
  )
}

export default OneClickErrorText

const style = css`
  font-size: 13px;
  color: ${COLOR_CODE.RED};
`
